import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

// ─── Global auth interceptor ──────────────────────────────────────────────────
// Injects Bearer token into all /api/ requests that lack an Authorization header.
// Fixes ~49 pages that use `credentials: 'include'` (pre-migration pattern) where
// the backend only reads the Authorization header, not cookies.
const _origFetch = window.fetch.bind(window);
window.fetch = function (input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const url = input instanceof Request ? input.url : String(input);
  if (url.startsWith('/api/')) {
    const token = localStorage.getItem('auth_token');
    if (token) {
      const existing = init?.headers;
      const hasAuth = existing instanceof Headers
        ? existing.has('Authorization')
        : existing != null && 'Authorization' in (existing as Record<string, string>);
      if (!hasAuth) {
        const headers = new Headers(existing ?? {});
        headers.set('Authorization', `Bearer ${token}`);
        init = { ...init, headers };
      }
    }
  }
  return _origFetch(input, init);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA functionality
// if (import.meta.env.PROD) {
//   registerServiceWorker();
// }
